import { Component } from "react";
import Select from "react-select";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

import { fetchSections } from "../../../store/slices/admin/sections";
import { DebouncedFunc, debounce } from "lodash";

type Props = {
	isEdit: boolean;
	sections: Array<string>;
	updateConfig: Function;
	// injected
	dispatch: Function;
	brandId: string,
	type: string,
	sectionsData: Array<number>;
	isLoadingSections: boolean;
	isSectionsDisabled: boolean;
};

type OptionType = {
	value: string;
	label: string;
};

type State = {
	selectedSections: OptionType[];
};

class GoalSections extends Component<Props, State> {
	additionalSections: Array<string>;
	getSectionOptions: DebouncedFunc<(inputValue: string) => void>;

	constructor(props: Props) {
		super(props);
		
		this.state = {
			selectedSections: []
		};

		this.getSectionOptions = debounce(this._getSectionOptions, 400);
		this.additionalSections = props.isEdit ? props.sections : [];

		this.onSectionChange = this.onSectionChange.bind(this);
	}

	static defaultProps = {
		isSectionsDisabled: false,
	};

	componentDidMount() {
		this.props.dispatch(fetchSections(this.props.brandId, this.props.type, "", this.additionalSections, 1));
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.isEdit) {
			if (
				!isEqual(prevProps.sectionsData, this.props.sectionsData) ||
				!isEqual(prevProps.sections, this.props.sections)
			) {
				this.setInitSections();
			}
		}

		if (prevProps.type !== this.props.type) {
			this.setState({ selectedSections: [] });
			this.props.dispatch(fetchSections(this.props.brandId, this.props.type, "", this.additionalSections, 1));
		}
	}

	_getSectionOptions = (inputValue: string) => {
		this.props.dispatch(fetchSections(this.props.brandId, this.props.type, inputValue, this.additionalSections, 1));
	};

	setInitSections() {
		const sections = this.props.sections;
		const sectionsData: any = this.props.sectionsData[1];
		let selectedSections: any[] = [];
		if (sectionsData && sections.length > 0) {
			// @ts-ignore
			if (sectionsData && sectionsData[this.props.brandId]) {
				// @ts-ignore
				selectedSections = [
					...selectedSections,
					...sectionsData[this.props.brandId],
				];
				selectedSections = selectedSections.filter(
					(item) => sections.indexOf(item.value) !== -1
				);
			}
		}

		this.setState({ selectedSections });
	}

	getOptions() {
		let selectSections: any[] = [];
		const sectionsData: any = this.props.sectionsData[1];
		
		// @ts-ignore
		if (sectionsData && sectionsData[this.props.brandId]) {
			// @ts-ignore
			selectSections = [
				...selectSections,
				...sectionsData[this.props.brandId],
			];
		}
		
		return selectSections;
	}

	onSectionChange(value: OptionType[]) {
		this.setState({ selectedSections: value }, () => {
			this.props.updateConfig(
				"sections",
				!value || value.length < 1
					? []
					: value.map((item) => item.value),
			);
		});
	}
	
	render() {
		return (
			<div className="config-item__selects">
				<div className="form-group">
					<label htmlFor="sections">Full site/Sections</label>
					<Select
						id="sections"
						className="basic-single"
						classNamePrefix="so-select-sort"
						isSearchable={true}
						isMulti
						value={this.state.selectedSections}
						options={this.getOptions()}
						onChange={(option) =>
							this.onSectionChange(option as OptionType[])
						}
						onInputChange={this.getSectionOptions}
						closeMenuOnSelect={false}
						isLoading={this.props.isLoadingSections}
						menuPortalTarget={document.body}
						styles={{
							menuPortal: (base) => ({ ...base, zIndex: 9999 }),
						}}
						isDisabled={this.props.isSectionsDisabled}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => {
	
	return {
		sectionsData: state.sections.cellId ? state.sections.data : [],
		isLoadingSections: state.sections ? state.sections.isLoading : false,
	};
};

export default connect(mapStateToProps)(GoalSections);
